import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setBackButtonUrl } from "../uiSlice";
import { BACKGROUNDS, PEOPLE, UI } from "../desi/desiAssets";
import useDesiBackground from "../desi/useDesiBackground";
import { GAMES, WELCOME_ROUTE } from "../desi/gameConfig";
import "./rules.css";

const ICON_PROPS = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

const RULES = [
  {
    title: "Travel",
    text: "Travel virtually across 6 states to experience Navrang festivities",
    icon: (
      <svg {...ICON_PROPS}>
        <path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z" />
        <circle cx="12" cy="9.5" r="2.5" />
      </svg>
    ),
  },
  {
    title: "Discover",
    text: "Discover how each of these states uniquely celebrate this festival",
    icon: (
      <svg {...ICON_PROPS}>
        <path d="M10.5 4l2 5.5L18 11.5l-5.5 2-2 5.5-2-5.5L3 11.5l5.5-2z" />
        <path d="M19 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z" />
      </svg>
    ),
  },
  {
    title: "Complete",
    text: "Complete all stages to ace in the race",
    icon: (
      <svg {...ICON_PROPS}>
        <path d="M8 4h8v5a4 4 0 0 1-8 0z" />
        <path d="M8 6H5v1.5A3 3 0 0 0 8 10.5M16 6h3v1.5a3 3 0 0 1-3 3" />
        <path d="M12 13v4M9 20h6M10 17h4" />
      </svg>
    ),
  },
];

/** rules.php */
function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [nextLoading, setNextLoading] = useState(false);

  // Desktop keeps the orange rules art; portrait phones use the same dark mobile bg as the other screens.
  useDesiBackground(BACKGROUNDS.rulesDesk, BACKGROUNDS.mob);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch]);

  const handleContinue = useCallback(
    (e) => {
      e.preventDefault();
      if (!user || nextLoading) return;
      setNextLoading(true);
      navigate(WELCOME_ROUTE, { replace: true });
    },
    [user, nextLoading, navigate]
  );

  return (
    <div className="rules-page">
      <img
        className="rules-logo"
        src={UI.welcomeLogoPng}
        alt="Desi Race"
        draggable={false}
      />
      <img
        className="rules-heading"
        src={UI.rulesText}
        alt="Rules"
        draggable={false}
      />

      <ol className="rules-cards">
        {RULES.map((rule, i) => (
          <li key={rule.title} className="rules-card" style={{ "--i": i }}>
            <span className="rules-card__step">Step {i + 1}</span>
            <span className="rules-card__icon">{rule.icon}</span>
            <h2 className="rules-card__title">{rule.title}</h2>
            <p className="rules-card__text">{rule.text}</p>
          </li>
        ))}
      </ol>

      <div className="rules-track" aria-label="Six states to race through">
        <span className="rules-track__tag rules-track__tag--start">Start</span>
        <div className="rules-track__stops">
          {GAMES.map((game, i) => (
            <img
              key={game.key}
              className="rules-track__stop"
              style={{ "--i": i }}
              src={PEOPLE[game.key]}
              alt={game.state}
              draggable={false}
            />
          ))}
        </div>
        <span className="rules-track__tag rules-track__tag--finish">Finish</span>
      </div>

      <button
        type="button"
        className="rules-next-btn"
        disabled={nextLoading || !user}
        onClick={handleContinue}
      >
        {nextLoading ? "Loading…" : "Let’s race"}
      </button>
    </div>
  );
}

export default UserRules;
